import { render, staticRenderFns } from "./TheSearchAI.vue?vue&type=template&id=564e95d8&"
import script from "./TheSearchAI.vue?vue&type=script&lang=js&"
export * from "./TheSearchAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564e95d8')) {
      api.createRecord('564e95d8', component.options)
    } else {
      api.reload('564e95d8', component.options)
    }
    module.hot.accept("./TheSearchAI.vue?vue&type=template&id=564e95d8&", function () {
      api.rerender('564e95d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheSearchAI.vue"
export default component.exports